import { DEFAULT_YA_METRICS_COUNTER } from "scripts/constants";
import { throwError } from "scripts/data_utils/throwError";
import { getGlobal } from "./global";
import { tryCatch } from "./tryCatch";

const checkEnabled = () => {
  return getGlobal("__ANALYTICS_ENABLE__") && !getGlobal("app").user.isModerator;
};

const sendYaMetricksEvent = (goal, goalParams = {}, key = DEFAULT_YA_METRICS_COUNTER) => {
  if (!checkEnabled()) {
    return false;
  }

  const yaKey = key ? key : DEFAULT_YA_METRICS_COUNTER;
  const counter = getGlobal(yaKey);

  if (typeof counter !== "object" || !goal) {
    return false;
  }

  const [error, value] = tryCatch(() => counter.reachGoal(goal, goalParams));

  if (error) {
    throwError({
      error,
      properties: {
        event: "YandexMetrics-warning",
        goal: `${goal}`,
        message: e.message
      }
    });
  }

  console.info('Send ya event', goal, goalParams);
  return true;
};

export { sendYaMetricksEvent };